import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Navbar from '../../../../components/navbar';
import Footer from '../../../../components/footer';
import Button from '../../../../components/Button';
import { useConsultation } from '../../../../context/ConsultationContext';
import { handleTreatmentServiceNavigation } from '../components/treatmentNavigationHelper';
import styles from './css/BloodPressure.module.css';
import newStyles from './css/DiabetesConsult.module.css';
import { Flame, Send } from 'lucide-react';
import Dropdown from '../../../../components/Dropdown';

const DiabetesConsult = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { consultationData, updateConsultationData, getStepDraft, setStepDraft, goToStep } = useConsultation();

    const patient = location?.state?.patient || consultationData?.patient || {};
    const patientName = `${patient?.firstname || ""} ${patient?.surname || ""}`.trim() || "Thandiwe Ndlovu";
    const profileNumber = patient?.profilenumber || "448896";
    const initials = `${patient?.firstname?.[0] || ""}${patient?.surname?.[0] || ""}`.toUpperCase() || "TN";

    // Glucose readings states
    const [bloodGlucose, setBloodGlucose] = useState('');
    const [hba1c, setHba1c] = useState('');
    
    // Assessment states
    const [response, setResponse] = useState('');
    const [footCheckPerformed, setFootCheckPerformed] = useState(false);
    
    // Other states
    const [clinicalNotes, setClinicalNotes] = useState('');

    const handleInvoice = () => {
        handleTreatmentServiceNavigation({
            location,
            navigate,
            consultationData,
            updateConsultationData,
            getStepDraft,
            setStepDraft,
            goToStep,
            serviceData: {
                diabetes_consult: {
                    bloodGlucose,
                    hba1c,
                    response,
                    footCheckPerformed,
                    clinicalNotes,
                },
            },
        });
    };

    useEffect(() => {
        document.body.classList.add(styles.hideSidebar);
        return () => {
            document.body.classList.remove(styles.hideSidebar);
        };
    }, []);

    return (
        <div className={styles.bloodPressureContainer}>
            <Navbar />

            <main className={styles.mainContent}>
                <div className={styles.card}>
                    <div className={styles.cardHeader}>
                        <div className={styles.headerIcon} aria-hidden="true">
                            <Flame />
                        </div>
                        <h1 className={newStyles.title}>Diabetes Consult</h1>
                    </div>

                    <div className={styles.patientCard}>
                        <div className={styles.avatar} aria-hidden="true">{initials}</div>
                        <div className={styles.patientText}>
                            <div className={styles.patientName}>{patientName}</div>
                            <div className={styles.patientMetaRow}>
                                <span className={styles.profileInfo}>Profile: {profileNumber}</span>
                                <span className={styles.dependentBadge}>Dependent</span>
                            </div>
                        </div>
                    </div>

                    <div className={styles.sectionBlock}>
                        <div className={styles.sectionTitle}>READINGS</div>
                        <div className={newStyles.readingsRow1}>
                            <div className={styles.readingItem}>
                                <label className={styles.readingLabel}>Blood Glucose</label>
                                <div className={styles.inputGroup}>
                                    <input
                                        type="number"
                                        value={bloodGlucose}
                                        onChange={(e) => setBloodGlucose(e.target.value)}
                                        className={newStyles.readingInput}
                                        placeholder='—'
                                    />
                                    <span className={styles.unit}>mmol/L</span>
                                </div>
                            </div>

                            <div className={styles.readingItem}>
                                <label className={styles.readingLabel}>HbA1c (if available)</label>
                                <div className={styles.inputGroup}>
                                    <input
                                        type="number"
                                        value={hba1c}
                                        onChange={(e) => setHba1c(e.target.value)}
                                        className={newStyles.readingInput}
                                        placeholder='—'
                                    />
                                    <span className={styles.unit}>%</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={styles.sectionBlock}>
                        <div className={styles.sectionTitle}>ASSESSMENTS</div>
                        <div className={newStyles.readingsRow}>
                            <div className={styles.readingItem}>
                                <label className={styles.readingLabel}>Medication adherence</label>
                                <div className={styles.inputGroup}>
                                    <Dropdown
                                        name="response"
                                        value={response}
                                        onChange={setResponse}
                                        options={['Improved', 'No Change', 'Worsened']}
                                        placeholder="Select..."
                                        className={newStyles.readingInput}
                                        alignLeft
                                    />
                                </div>
                            </div>
                        </div>

                        <div className={newStyles.toggleSection}>
                            <label className={styles.toggleLabel}>Foot check performed</label>
                            <button
                                type="button"
                                className={`${styles.toggleButton} ${footCheckPerformed ? styles.active : ''}`}
                                onClick={() => setFootCheckPerformed(!footCheckPerformed)}
                                aria-pressed={footCheckPerformed}
                            >
                                <div className={styles.toggleSlider}></div>
                            </button>
                        </div>
                    </div>

                    <div className={styles.sectionBlock}>
                        <div className={styles.fieldLabel}>Clinical Notes</div>
                        <textarea
                            value={clinicalNotes}
                            onChange={(e) => setClinicalNotes(e.target.value)}
                            className={styles.clinicalNotes}
                            placeholder="Enter clinical notes..."
                            rows={6}
                        />
                    </div>

                    <div className={styles.cardFooter}>
                        <Button
                            onClick={handleInvoice}
                            className={styles.invoiceButton}
                            type="button"
                        >
                            <Send size={16} />
                            Invoice
                        </Button>
                    </div>
                </div>
            </main>

            <Footer />
        </div>
    );
};

export default DiabetesConsult;